// Work Orders Page - Using MUI DataGrid and Bootstrap Modal
import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc, query, orderBy, limit } from "firebase/firestore";
import { db } from "../App";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Modal, Form } from "react-bootstrap";

const WorkOrders = () => {
  const [workOrders, setWorkOrders] = useState([]);
  const [newWorkOrder, setNewWorkOrder] = useState({
    assetName: "",
    problemDescription: "",
    priority: "",
    assignedTo: "",
    status: "",
    resolutionNotes: "",
    dateCreated: "",
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchWorkOrders = async () => {
      const querySnapshot = await getDocs(collection(db, "work_orders"));
      const workOrdersList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setWorkOrders(workOrdersList);
    };
    fetchWorkOrders();
  }, []);

  const generateWorkOrderID = async () => {
    const workOrderQuery = query(collection(db, "work_orders"), orderBy("workOrderID", "desc"), limit(1));
    const querySnapshot = await getDocs(workOrderQuery);
    if (!querySnapshot.empty) {
      const lastID = querySnapshot.docs[0].data().workOrderID;
      const newID = parseInt(lastID, 10) + 1;
      return newID.toString().padStart(5, "0");
    } else {
      return "00001";
    }
  };

  const handleAddWorkOrder = async () => {
    try {
      const newID = await generateWorkOrderID();
      const workOrderToAdd = { ...newWorkOrder, workOrderID: newID };
      await addDoc(collection(db, "work_orders"), workOrderToAdd);
      setWorkOrders([...workOrders, workOrderToAdd]);
      setNewWorkOrder({
        assetName: "",
        problemDescription: "",
        priority: "",
        assignedTo: "",
        status: "",
        resolutionNotes: "",
        dateCreated: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error("Error adding work order: ", error);
    }
  };

  const columns = [
    { field: "workOrderID", headerName: "Work Order ID", width: 150 },
    { field: "assetName", headerName: "Asset Name", width: 200 },
    { field: "problemDescription", headerName: "Problem Description", width: 250 },
    { field: "priority", headerName: "Priority", width: 150 },
    { field: "assignedTo", headerName: "Assigned To", width: 200 },
    { field: "status", headerName: "Status", width: 150 },
    { field: "resolutionNotes", headerName: "Resolution Notes", width: 300 },
    { field: "dateCreated", headerName: "Date Created", width: 150 },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <h2>Work Orders</h2>

      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className="mb-2"
      >
        Add New Work Order
      </Button>
      
      <div style={{ height: 350, width: 1150 }}>
        <DataGrid 
        getRowId={(row) => row.assetName}
          rows={workOrders}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
          style={{ backgroundColor: "white" }}
        />
      </div>
      

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Work Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Asset Name</Form.Label>
              <Form.Control
                type="text"
                value={newWorkOrder.assetName}
                onChange={(e) => setNewWorkOrder({ ...newWorkOrder, assetName: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Problem Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={newWorkOrder.problemDescription}
                onChange={(e) => setNewWorkOrder({ ...newWorkOrder, problemDescription: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Priority</Form.Label>
              <Form.Control
                type="text"
                value={newWorkOrder.priority}
                onChange={(e) => setNewWorkOrder({ ...newWorkOrder, priority: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Assigned To</Form.Label>
              <Form.Control
                type="text"
                value={newWorkOrder.assignedTo}
                onChange={(e) => setNewWorkOrder({ ...newWorkOrder, assignedTo: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control
                type="text"
                value={newWorkOrder.status}
                onChange={(e) => setNewWorkOrder({ ...newWorkOrder, status: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Resolution Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={newWorkOrder.resolutionNotes}
                onChange={(e) => setNewWorkOrder({ ...newWorkOrder, resolutionNotes: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Date Created</Form.Label>
              <Form.Control
                type="date"
                value={newWorkOrder.dateCreated}
                onChange={(e) => setNewWorkOrder({ ...newWorkOrder, dateCreated: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddWorkOrder}>
            Save Work Order
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WorkOrders;